'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { defaultProps, COMPONENT_ID } from './TextField.contract.js';
import { useInputProps } from '../Input/useInputProps.js';
import { Input } from '../Input/Input/Input.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var TextField = /*#__PURE__*/ forwardRef(function(props, ref) {
    var _useInputProps = useInputProps(COMPONENT_ID, _extends({}, defaultProps, {
        __staticSelector: COMPONENT_ID
    }), props), inputProps = _useInputProps.inputProps, wrapperProps = _useInputProps.wrapperProps, others = _object_without_properties_loose(_useInputProps, [
        "inputProps",
        "wrapperProps"
    ]);
    return /*#__PURE__*/ jsx(Input.Root, _extends({}, wrapperProps, {
        children: /*#__PURE__*/ jsx(Input, _extends({}, inputProps, others, {
            ref: ref
        }))
    }));
});
var TextField$1 = TextField;
TextField.displayName = COMPONENT_ID;

export { TextField, TextField$1 as default };
